/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Add_NotesInputs */

const en_applications_add_notes = /** @type {(inputs: Applications_Add_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add notes`)
};

const de_applications_add_notes = /** @type {(inputs: Applications_Add_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Notizen hinzufügen`)
};

const fr_applications_add_notes = /** @type {(inputs: Applications_Add_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Ajouter des notes`)
};

const es_applications_add_notes = /** @type {(inputs: Applications_Add_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Agregar notas`)
};

const it_applications_add_notes = /** @type {(inputs: Applications_Add_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Aggiungi note`)
};

const nl_applications_add_notes = /** @type {(inputs: Applications_Add_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Notities toevoegen`)
};

const pl_applications_add_notes = /** @type {(inputs: Applications_Add_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Dodaj notatki`)
};

const fi_applications_add_notes = /** @type {(inputs: Applications_Add_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lisää muistiinpanoja`)
};

const da_applications_add_notes = /** @type {(inputs: Applications_Add_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Tilføj noter`)
};

const sv_applications_add_notes = /** @type {(inputs: Applications_Add_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lägg till anteckningar`)
};

/**
* | output |
* | --- |
* | "+ Add notes" |
*
* @param {Applications_Add_NotesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_add_notes = /** @type {((inputs?: Applications_Add_NotesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Add_NotesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_add_notes(inputs)
	if (locale === "fr") return fr_applications_add_notes(inputs)
	if (locale === "es") return es_applications_add_notes(inputs)
	if (locale === "it") return it_applications_add_notes(inputs)
	if (locale === "nl") return nl_applications_add_notes(inputs)
	if (locale === "pl") return pl_applications_add_notes(inputs)
	if (locale === "fi") return fi_applications_add_notes(inputs)
	if (locale === "da") return da_applications_add_notes(inputs)
	if (locale === "sv") return sv_applications_add_notes(inputs)
	return en_applications_add_notes(inputs)
});